<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <LoginTreasureViewOne @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>

    <!-- theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <LoginTreasureViewTwo @get-deposit-claim="() => emits('getDepositClaim')"
            @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>
    <!-- theme Three -->
    <div v-if="themeStore.themeIndex === 3">
        <LoginTreasureViewThree @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>
    <!-- theme Four -->
    <div v-if="themeStore.themeIndex === 4">
        <LoginTreasureViewFour @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores/theme';
import LoginTreasureViewOne from '@/themes/themeOne/loginTreasure/loginTreasureView.vue';
import LoginTreasureViewTwo from '@/themes/themeTwo/loginTreasure/loginTreasureView.vue';
import LoginTreasureViewThree from '@/themes/themeThree/loginTreasure/loginTreasureView.vue';
import LoginTreasureViewFour from '@/themes/themeFour/loginTreasure/loginTreasureView.vue';
const themeStore = useThemeStore()
const emits = defineEmits(['getDepositClaim', 'resetShowTreasurePopup'])
const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
</script>
